import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * question endpoints
 */
export const fetchQuizQuestions = ({quizId, q, page, perPage, sortOpts, extraParams}, signal) =>
  request.fetchListEnhanced(
    {
      url: '/question',
      q,
      page,
      perPage,
      sortOpts,
      extraParams: {quizId, type: 'single_select', ...extraParams},
    },
    signal,
  );

export const fetchAllQuestions = () =>
  request.fetchList('/question', undefined, undefined, undefined, {sortField: 'points', sortDir: 'asc'});

export const fetchQuestion = (questionId) => request.fetchDetail(`/question/${questionId}`);

export const createQuestion = (payload) => {
  let options = [];
  Object.entries(payload)
    .filter(([key]) => key.includes('option'))
    .forEach(([key, value]) => options.push(value));
  const data = excludeObjNullValue({
    title: payload.title,
    options: options,
    answer: payload.answer,
    quiz_id: payload.quizId,
  });
  return request.postJSON('/question', data, {type: 'single_select'});
};

export const updateQuestion = (payload) => {
  let options = [];
  Object.entries(payload)
    .filter(([key]) => key.includes('option'))
    .forEach(([key, value]) => options.push(value));
  const data = excludeObjNullValue({
    title: payload.title,
    options: options,
    answer: payload.answer,
  });
  return request.putJSON(`/question/${payload.id}`, data, {type: 'single_select'});
};

export const deleteQuestion = (questionId) => request.deleteReq(`/question/${questionId}`);

export const createReaderQuestionAnswerAndQuizResult = (payload) => {
  const data = excludeObjNullValue({
    reader_id: payload.readerId,
    quiz_id: payload.quizId,
    correct_answer_cnt: payload.correctAnswerCnt,
    total_question_cnt: payload.totalQuestionCnt,
    question_and_answer: payload.questionAndAnswer,
  });
  return request.postJSON('/reader-question-answer', data);
};
